import axios from '@service'
import { PHONE_REGISTER } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

export default async function phoneRegisterService(payload = {}, config = {}) {
    const param = {
        ...PHONE_REGISTER,
        ...config,
        data: payload
    }
    const { data } = await axios(param)
    if (data.code === HTTP_ERR_SUCCESS) {
        return data
    } else {
        throw new Error(data.errorMessage || data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
